var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_32905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.90625 2.625V4.59375M13.0938 2.625V4.59375M0.625 16.4062V6.5625C0.625 6.04036 0.832421 5.5396 1.20163 5.17038C1.57085 4.80117 2.07161 4.59375 2.59375 4.59375H14.4062C14.9284 4.59375 15.4292 4.80117 15.7984 5.17038C16.1676 5.5396 16.375 6.04036 16.375 6.5625V16.4062M0.625 16.4062C0.625 16.9284 0.832421 17.4292 1.20163 17.7984C1.57085 18.1676 2.07161 18.375 2.59375 18.375H14.4062C14.9284 18.375 15.4292 18.1676 15.7984 17.7984C16.1676 17.4292 16.375 16.9284 16.375 16.4062M0.625 16.4062V9.84375C0.625 9.32161 0.832421 8.82085 1.20163 8.45163C1.57085 8.08242 2.07161 7.875 2.59375 7.875H14.4062C14.9284 7.875 15.4292 8.08242 15.7984 8.45163C16.1676 8.82085 16.375 9.32161 16.375 9.84375V16.4062M8.5 11.1562H8.507V11.1633H8.5V11.1562ZM8.5 13.125H8.507V13.132H8.5V13.125ZM8.5 15.0938H8.507V15.1007H8.5V15.0938ZM6.53125 13.125H6.53825V13.132H6.53125V13.125ZM6.53125 15.0938H6.53825V15.1007H6.53125V15.0938ZM4.5625 13.125H4.5695V13.132H4.5625V13.125ZM4.5625 15.0938H4.5695V15.1007H4.5625V15.0938ZM10.4688 11.1562H10.4758V11.1633H10.4688V11.1562ZM10.4688 13.125H10.4758V13.132H10.4688V13.125ZM10.4688 15.0938H10.4758V15.1007H10.4688V15.0938ZM12.4375 11.1562H12.4445V11.1633H12.4375V11.1562ZM12.4375 13.125H12.4445V13.132H12.4375V13.125Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_32905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.6519,
    height: 21,
    fill: "white",
    transform: "translate(-0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateCalendar);
export default __webpack_public_path__ + "static/media/date_calendar.397638b90d06fcdf4929a0cbfba536a9.svg";
export { ForwardRef as ReactComponent };